export const VALIDATE_GROUP_DETAILS = 'VALIDATE_GROUP_DETAILS'
export const VALIDATE_SEARCH_DETAILS = 'VALIDATE_SEARCH_DETAILS'
export const VALIDATE_FLIGHT_OFFERS = 'VALIDATE_FLIGHT_OFFERS'
export const VALIDATE_ANCILLARIES = 'VALIDATE_ANCILLARIES'
export const VALIDATE_BOOKER_DETAILS = 'VALIDATE_BOOKER_DETAILS'

export const validateGroupDetails = data => {
  return {
    type: VALIDATE_GROUP_DETAILS,
    data,
  }
}

export const validateSearchDetails = data => {
  return {
    type: VALIDATE_SEARCH_DETAILS,
    data,
  }
}

export const validateFlightOffers = data => {
  return {
    type: VALIDATE_FLIGHT_OFFERS,
    data,
  }
}

export const validateAncillaries = data => {
  return {
    type: VALIDATE_ANCILLARIES,
    data,
  }
}

export const validateBookerDetails = data => {
  return {
    type: VALIDATE_BOOKER_DETAILS,
    data,
  }
}
